import React, { useEffect } from "react";
import { Box } from "@mui/material";
import SupportMain from "./main";
import ContactChannels from "./contactChannels";
// import Branches from "./branches";
import ConcernForm from "./concernForm";
import SupportPromise from "./promise";
import FraudReport from "./fraudReport";
import HelpLibrary from "./helpLibrary";
import StillNeedHelp from "./stillNeedHelp";
import Footer from "../../components/footer";

const IndexSupport = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ overflowX: "clip" }}>
      <SupportMain />

      {/* Soft alternating gradient backdrop covering every section from
          "Talk to us" through "Still need help". Each color band roughly
          aligns with one section. */}
      <Box
        sx={{
          position: "relative",
          width: "100vw",
          marginLeft: "calc(50% - 50vw)",
          background:
            "linear-gradient(to bottom, #FFFFFF 0%, #F5FDFA 18%, #F6F4EE 36%, #F5FDFA 54%, #F6F4EE 72%, #FFFFFF 100%)",
        }}
      >
        <ContactChannels />
        {/* <Branches /> */}

        <Box
          sx={{
            "@media (min-width: 1700px)": {
              maxWidth: "70vw",
              margin: "auto",
            },
            "@media (min-width: 1600px) and (max-width: 1800px)": {
              maxWidth: "90vw",
              margin: "auto",
            },
          }}
        >
          <ConcernForm />
          <SupportPromise />
        </Box>

        <FraudReport />
        <HelpLibrary />
        <StillNeedHelp />
      </Box>

      <Footer />
    </div>
  );
};

export default IndexSupport;
